module.exports = __webpack_public_path__ + "static/media/DSC_0248.033f512e.JPG";